<script lang="ts">
    import ErpTwoSplitLayout from 'src/features/erp/components/ErpTwoSplitLayout.svelte';
</script>

<ErpTwoSplitLayout pageClass="sutor-report-optimisation-overviews" ratios="{[2, 1]}">
    <div slot="left-panel">
        Denní přehled
    </div>

    <div slot="right-panel">
        Předávací protokol
    </div>
</ErpTwoSplitLayout>